export default __webpack_public_path__ + "static/IBMPlexSans-Light-69d4ee16878073675cbecada47d9eea1.woff";